import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/88a08bdd-1e11-4d02-9b3c-556bb9050443.jpg'
import { useIntl } from 'react-intl';

const TravBusinessReportingInsightsPage: React.FC = () => {
  const intl = useIntl();
  const tocItems: ITableOfContentItem[] = [
    { id: 'real-time-data', title: intl.formatMessage({ id: 'reporting.insights.real.time.data' }) },
    { id: 'customizable-reports', title: intl.formatMessage({ id: 'reporting.insights.customizable.reports' }) },
    { id: 'visual-dashboards', title: intl.formatMessage({ id: 'reporting.insights.visual.dashboards' }) },
    { id: 'budget-forecasting', title: intl.formatMessage({ id: 'reporting.insights.budget.forecasting' }) },
    { id: 'shareable-insights', title: intl.formatMessage({ id: 'reporting.insights.shareable.insights' }) },
  ];
  
const sections: IContentSection[] = [
  {
    id: 'reporting.insights.real.time.data',
    title: intl.formatMessage({ id: 'reporting.insights.real.time.data' }),
    paragraphs: [
      intl.formatMessage({ id: 'reporting.insights.real.time.data.p1' }),
      intl.formatMessage({ id: 'reporting.insights.real.time.data.p2' }),
    ],
  },
  {
    id: 'reporting.insights.customizable.reports',
    title: intl.formatMessage({ id: 'reporting.insights.customizable.reports' }),
    paragraphs: [
      intl.formatMessage({ id: 'reporting.insights.customizable.reports.p1' }),
      intl.formatMessage({ id: 'reporting.insights.customizable.reports.p2' }),
    ],
  },
  {
    id: 'reporting.insights.visual.dashboards',
    title: intl.formatMessage({ id: 'reporting.insights.visual.dashboards' }),
    paragraphs: [
      intl.formatMessage({ id: 'reporting.insights.visual.dashboards.p1' }),
    ],
  },
  {
    id: 'reporting.insights.budget.forecasting',
    title: intl.formatMessage({ id: 'reporting.insights.budget.forecasting' }),
    paragraphs: [
      intl.formatMessage({ id: 'reporting.insights.budget.forecasting.p1' }),
      intl.formatMessage({ id: 'reporting.insights.budget.forecasting.p2' }),
    ],
  },
  {
    id: 'reporting.insights.shareable.insights',
    title: intl.formatMessage({ id: 'reporting.insights.shareable.insights' }),
    paragraphs: [
      intl.formatMessage({ id: 'reporting.insights.shareable.insights.p1' }),
      intl.formatMessage({ id: 'reporting.insights.shareable.insights.p2' }),
    ],
  }
];


  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={intl.formatMessage({ id: 'reporting.insights.title' })}
        headerSubtitle={intl.formatMessage({ id: 'reporting.insights.subtitle' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='center'
      />
    </div>
  );
};

export default TravBusinessReportingInsightsPage;
